(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('PartyDetailController', PartyDetailController);

    PartyDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'Party', 'DocumentWorkItem', 'DocumentEvent', 'User', 'AppAccount'];

    function PartyDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, Party, DocumentWorkItem, DocumentEvent, User, AppAccount) {
        var vm = this;

        vm.party = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('jmrsignApp:partyUpdate', function(event, result) {
            vm.party = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
